import React, { useState } from 'react'

import clawIcon from '../assets/claw_icon.png'
import { markClawBetaApprovedShown } from '../clawBetaModalConfig'
import './ClawBetaApprovedModal.scss'
import {
  ArrowRightOutlined,
  CheckCircleFilled,
  CheckOutlined,
  CloseOutlined
} from '@ant-design/icons'

interface Props {
  visible: boolean
  teamShortId?: string
  onStart: () => void
  onClose: () => void
}

const ClawBetaApprovedModal: React.FC<Props> = ({
  visible,
  teamShortId,
  onStart,
  onClose
}) => {
  const [collapsed, setCollapsed] = useState(false)

  if (!visible) return null

  if (collapsed) {
    return (
      <div className="claw-beta-modal">
        <div
          className="claw-beta-modal__collapsed"
          onClick={() => setCollapsed(false)}
          title="展开内测通知"
        >
          <img src={clawIcon} alt="今日龙虾Claw" />
          <span className="claw-beta-modal__collapsed-badge">
            <CheckOutlined />
          </span>
        </div>
      </div>
    )
  }

  return (
    <div className="claw-beta-modal">
      <div className="claw-beta-modal__card">
        {/* 右上角：不再展示 + 关闭 */}
        <button
          className="claw-beta-modal__close"
          onClick={() => {
            markClawBetaApprovedShown(teamShortId)
            onClose()
          }}
        >
          <span>不再展示</span>
          <CloseOutlined />
        </button>

        {/* 顶部渐变横幅 */}
        <div className="claw-beta-modal__banner">
          <span className="claw-beta-modal__sparkle claw-beta-modal__sparkle--1">
            &#10024;
          </span>
          <span className="claw-beta-modal__sparkle claw-beta-modal__sparkle--2">
            &#10024;
          </span>
          <span className="claw-beta-modal__sparkle claw-beta-modal__sparkle--3">
            &#127881;
          </span>
          <span className="claw-beta-modal__sparkle claw-beta-modal__sparkle--4">
            &#10024;
          </span>
        </div>

        {/* 通过徽章 */}
        <div className="claw-beta-modal__check-badge">
          <CheckOutlined />
        </div>

        {/* 内容区 */}
        <div className="claw-beta-modal__body">
          <h2 className="claw-beta-modal__title">内测申请已通过</h2>
          <p className="claw-beta-modal__subtitle">
            恭喜！您已获得今日龙虾Claw内测资格
          </p>

          {/* 品牌图标 */}
          <img
            className="claw-beta-modal__logo"
            src={clawIcon}
            alt="今日龙虾Claw"
          />

          {/* 权益清单 */}
          <div className="claw-beta-modal__features">
            <div className="claw-beta-modal__feature">
              <CheckCircleFilled />
              <span>全部功能免费使用</span>
            </div>
            <div className="claw-beta-modal__feature">
              <CheckCircleFilled />
              <span>专属内测用户反馈通道</span>
            </div>
            <div className="claw-beta-modal__feature">
              <CheckCircleFilled />
              <span>正式版上线后优先升级</span>
            </div>
          </div>

          {/* 按钮区 */}
          <button className="claw-beta-modal__btn-primary" onClick={onStart}>
            开启内测
            <ArrowRightOutlined />
          </button>
          <button
            className="claw-beta-modal__btn-secondary"
            onClick={() => setCollapsed(true)}
          >
            稍后再说
          </button>
        </div>
      </div>
    </div>
  )
}

export default ClawBetaApprovedModal
